/**
 * @generated SignedSource<<bbd356832bdd0d5877b675bdde53d4fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreateOrEditTeamGoogleWorkspaceGroupsQuery$variables = {};
export type CreateOrEditTeamGoogleWorkspaceGroupsQuery$data = {
  readonly account: {
    readonly integrations: {
      readonly gsuite: {
        readonly googleWorkspaceGroups: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }> | null;
      } | null;
    };
  };
};
export type CreateOrEditTeamGoogleWorkspaceGroupsQuery = {
  response: CreateOrEditTeamGoogleWorkspaceGroupsQuery$data;
  variables: CreateOrEditTeamGoogleWorkspaceGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "GoogleGroup",
  "kind": "LinkedField",
  "name": "googleWorkspaceGroups",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrEditTeamGoogleWorkspaceGroupsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GSuiteAccountNode",
                "kind": "LinkedField",
                "name": "gsuite",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateOrEditTeamGoogleWorkspaceGroupsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GSuiteAccountNode",
                "kind": "LinkedField",
                "name": "gsuite",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0d6561eaa282d04a83531537982bc92",
    "id": null,
    "metadata": {},
    "name": "CreateOrEditTeamGoogleWorkspaceGroupsQuery",
    "operationKind": "query",
    "text": "query CreateOrEditTeamGoogleWorkspaceGroupsQuery {\n  account {\n    integrations {\n      gsuite {\n        googleWorkspaceGroups {\n          id\n          externalId\n          name\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c072ef15d08cc635ae4e5f8ebd1407e7";

export default node;
